<template>
  <v-menu location="top end" :offset="4" content-class="variable-menu">
    <template #activator="{ props }">
      <button type="button" class="variable-btn" v-bind="props">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.25 9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75H9.75V14.25H8.25V9.75Z" fill="#858585"/>
        </svg>
        <span>Variabel</span>
      </button>
    </template>

    <div class="variable-menu__list">
      <div v-for="v in variables" :key="v.token" class="variable-menu__item" @click="onInsert(v)">
        <span class="variable-menu__label">{{ v.label }}</span>
        <button type="button" class="variable-menu__copy" @click.stop="onCopy(v)" aria-label="Kopieer">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.75 13.5C6.3375 13.5 5.98438 13.3531 5.69063 13.0594C5.39688 12.7656 5.25 12.4125 5.25 12V3C5.25 2.5875 5.39688 2.23438 5.69063 1.94063C5.98438 1.64688 6.3375 1.5 6.75 1.5H13.5C13.9125 1.5 14.2656 1.64688 14.5594 1.94063C14.8531 2.23438 15 2.5875 15 3V12C15 12.4125 14.8531 12.7656 14.5594 13.0594C14.2656 13.3531 13.9125 13.5 13.5 13.5H6.75ZM6.75 12H13.5V3H6.75V12ZM3.75 16.5C3.3375 16.5 2.98438 16.3531 2.69063 16.0594C2.39688 15.7656 2.25 15.4125 2.25 15V4.5H3.75V15H12V16.5H3.75Z" fill="#858585"/>
          </svg>
        </button>
      </div>
    </div>
  </v-menu>
</template>

<script>
import { VARIABLES } from "@/util/personalisation/variableRegistry";

export default {
  name: "variable-menu-button",
  emits: ["insert"],
  data() {
    return { variables: VARIABLES };
  },
  methods: {
    onInsert(v) {
      this.$emit("insert", v.token);
    },
    async onCopy(v) {
      try {
        await navigator.clipboard.writeText(v.token);
        this.$toast?.success?.("Gekopieerd naar klembord");
      } catch {
        this.$toast?.error?.("Kopiëren mislukt");
      }
    },
  },
};
</script>

<style scoped lang="scss">
/* Floats absolutely inside the host field's top-right — never takes layout space.
   The host wrapper must be position: relative. */
.variable-btn {
  display: flex;
  padding: 2px 8px 2px 4px;
  align-items: center;
  gap: 4px;
  border-radius: 5px;
  background: var(--neutral-100, #f5f5f5);
  position: absolute;
  right: 0;
  top: 2px;
  color: var(--neutral-500, #858585);
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 400;
  line-height: 100%;
  cursor: pointer;
  border: none;
  transition: background-color 0.15s ease;
  z-index: 1;
}
.variable-btn:hover {
  background: var(--neutral-200, #dfdfdf);
}
.variable-btn:active {
  background: var(--neutral-300, #c0c0c0);
}
</style>

<style lang="scss">
/* Not scoped: v-menu content renders in an overlay. !important beats Vuetify's
   overlay/list defaults. */
.variable-menu {
  border-radius: var(--Radius--small, 10px) !important;
  border: 1px solid var(--neutral-200, #dfdfdf) !important;
  background: var(--White, #fff) !important;
  box-shadow: 0 2px 4px 0 rgba(78, 78, 78, 0.1), 0 6px 24px 0 rgba(78, 78, 78, 0.08) !important;

  .variable-menu__list {
    display: flex !important;
    padding: 8px !important;
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }
  .variable-menu__item {
    display: flex !important;
    padding: 8px 12px !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 16px !important;
    align-self: stretch !important;
    width: 100% !important;
    border-radius: 2px !important;
    cursor: pointer !important;
    color: var(--neutral-500, #858585) !important;
    font-family: "Open Sans" !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 125% !important; /* 17.5px */
    background: transparent !important;
    transition: background-color 0.15s ease;

    .variable-menu__copy {
      border: none !important;
      background: none !important;
      cursor: pointer !important;
      display: inline-flex !important;
      padding: 0 !important;
      visibility: hidden; /* revealed on hover */
    }
    &:hover {
      background: var(--neutral-100, #f5f5f5) !important;
    }
    &:hover .variable-menu__copy {
      visibility: visible;
    }
  }
}
</style>
